export class PointBracket {
  constructor(pointsName) {
    this.pointsName = pointsName;
  }

  normal() {
    if (/^point?$/i.test(this.pointsName)) {
      return `${this.pointsName}s`;
    }
    return `Points (${this.pointsName}s)`;
  }

  capital() {
    const value = this.normal();
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}
